import enTranslations from '@/translations/en.json'
import csTranslations from '@/translations/cs.json'
import plTranslations from '@/translations/pl.json'
import nlTranslations from '@/translations/nl.json'
import deTranslations from '@/translations/de.json'
import huTranslations from '@/translations/hu.json'
import ptTranslations from '@/translations/pt.json'
import itTranslations from '@/translations/it.json'
import frTranslations from '@/translations/fr.json'
import esTranslations from '@/translations/es.json'

const languages = {
  en: enTranslations,
  cs: csTranslations,
  pl: plTranslations,
  nl: nlTranslations,
  de: deTranslations,
  hu: huTranslations,
  pt: ptTranslations,
  it: itTranslations,
  fr: frTranslations,
  es: esTranslations
}

interface Translations {
  previousSlide: string
  nextSlide: string
  menu: string
  searchContent: string
  mainNavigation: string
}

export const translateContent = (lang: LangCode, text: keyof Translations) => languages[lang][text]
